<template>
    <div class="row transform-unset" style="transform: translate(0px, 0px);" itemscope
        itemtype="https://schema.org/Thing">
        <div class="d-none d-lg-flex col-lg-2 single__thumb-swiper-container">
            <div class="single__thumb-swiper swiper-container swiper-container-vertical" ref="thumbs">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="imagePreview in carouselImages"
                        @mousedown="triggerClick($event.target)">
                        <div v-if="imagePreview.isVideo" class="single__video-thumb" :data-url="imagePreview.url"
                            data-type="video" :title="getItemName() + ' video'">
                            <svg>
                                <use xlink:href="#svg_play" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                            </svg>
                        </div>
                        <div v-else-if="imagePreview.is3d" class="single__3d-thumb" :data-url="imagePreview.url"
                            data-type="3d" :title="getItemName() + ' 3D'">
                            <svg>
                                <use xlink:href="#svg_3d" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                            </svg>
                        </div>
                        <img v-else class="single__thumb-swiper-image swiper-lazy" :data-src="imagePreview.url"
                            :data-bigimg="imagePreview.urlBig" data-type="img" :alt="getAltText(imagePreview)"
                            :title="getItemName()" draggable="false" :key="imagePreview.url">
                        <div v-if="!imagePreview.isVideo && !imagePreview.is3d" class="swiper-lazy-preloader"></div>
                    </div>
                </div>
            </div>
            <div class="thumb-swiper-next"><svg>
                    <use xlink:href="#svg_arrow" xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                </svg></div>
            <div class="thumb-swiper-prev"><svg>
                    <use xlink:href="#svg_arrow" xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                </svg></div>
        </div>
        <div class="col-12 col-lg-10 single-swiper-container-col">
            <div class="single__wishlist-btn single__wishlist-btn--top">
                <add-to-wish-list></add-to-wish-list>
            </div>
            <div class="swiper-container single-swiper" ref="single" @mouseover.once="triggerScrollForDrift()">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(image, index) in singleImages" :key="index"
                        :class="{ 'pointer-events-all': image.isVideo || image.is3d }">
                        <div v-if="image.isVideo && image.isYoutube" class="responsive-iframe--video">
                            <iframe :src="'https://www.youtube-nocookie.com/embed/' + image.url" frameborder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen itemprop="image">
                            </iframe>
                        </div>
                        <div v-else-if="image.isVideo && !image.isYoutube" class="responsive-iframe--video">
                            <iframe
                                :src="'https://player.vimeo.com/video/' + image.url + '?h=333e7b7c78&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479'"
                                width="100%" height="100%" frameborder="0" allow="fullscreen" allowfullscreen>
                            </iframe>
                        </div>
                        <div v-else-if="image.is3d" class="responsive-iframe--3d" ref="threedcontainer">
                            <iframe :data-src="image.url" frameborder="0" allowfullscreen itemprop="image">
                            </iframe>
                        </div>
                        <a v-else @click.prevent="openFullScreenModal($event)" :title="getItemName()">
                            <div class="swiper-zoom-container">
                                <img class="single__swiper-image" :class="{ 'swiper-lazy': index > 0 }"
                                    :data-zoom="image.urlBig" :src="index === 0 ? image.urlMiddle : ''"
                                    :data-src="image.urlMiddle" :alt="getAltText(image)" :title="getItemName()"
                                    itemprop="image" :key="image.urlMiddle">
                                <div v-if="index > 0" class="swiper-lazy-preloader"></div>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="single-swiper-pagination"></div>
                <div class="drift-pane" :class="'drift-pane-' + currentVariation.item.id"></div>
                <div class="single-swiper__fullscreen" @click.stop.prevent="openPhotoSwiper()">
                    {{ $translate("Weberbuero::Template.fullscreen") }}
                </div>
                <div class="swiper-button-next swiper-button-white"><svg>
                        <use xlink:href="#svg_arrow" xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                    </svg></div>
                <div class="swiper-button-prev swiper-button-white"><svg>
                        <use xlink:href="#svg_arrow" xmlns:xlink="https://www.w3.org/1999/xlink"></use>
                    </svg></div>
            </div>
        </div>
        <div v-if="(isItemView && itemData === null) || (!isItemView && itemData !== null)"
            class="single__swiper-full-screen-modal">
            <div class="single__swiper-full-screen-modal-close" @click="closeModal()"><svg data-dismiss="modal"
                    height="26" width="27">
                    <use xlink:href="#svg_close" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                </svg></div>
            <div class="single__swiper-full-screen-modal-img-wrapper">
                <img :alt="$store.getters.currentItemVariation.texts.name1" src=""
                    class="single__swiper-full-screen-modal-img">
                <iframe class="single__swiper-full-screen-modal-iframe" src="" frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen
                    itemprop="image">
                </iframe>
            </div>
        </div>
    </div>
</template>

<script>
import { isNullOrUndefined } from "ceres/app/helper/utils";

import { Swiper, Thumbs } from 'swiper';
import Drift from 'drift-zoom';
import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
import TranslationService from "ceres/app/services/TranslationService";

export default {
    name: "item-image-carousel",

    props: {
        maxQuantity:
        {
            type: Number,
            default: 25
        },
        imageUrlAccessor:
        {
            type: String,
            default: "url"
        },
        showThumbs:
        {
            type: Boolean,
            default: true
        },
        showDots:
        {
            type: Boolean,
            default: true
        },
        animationStyle:
        {
            type: String,
            default: "standard"
        },
        pluginPath:
        {
            type: String,
            default: ""
        },
        itemData:
        {
            type: Object,
            default: null
        },
    },

    inject: {
        itemId: {
            default: null
        }
    },

    data() {
        return {
            currentItem: 0,
            thumbsSwiper: null,
            singleSwiper: null,
            transform: "",
            varSwitched: false,
            initialized: false,
            usedItemId: this.itemData !== null ? this.itemData.item.id : this.itemId,
        };
    },

    computed:
    {
        pconUrl() {
            let part1 = ""
            for (let key in this.currentVariation.variationProperties) {
                for (let key2 in this.currentVariation.variationProperties[key].properties) {
                    if (this.currentVariation.variationProperties[key].properties[key2].id === 255) {
                        part1 = this.currentVariation.variationProperties[key].properties[key2].values.value;
                    }
                }
            }
            if (part1 === "") {
                return "";
            } else if (this.isPreview) {
                return "https://ui.pcon-solutions.com/#GATEKEEPER_ID=65e6c3945d3b2&moc=NARFC&ban=DJT101&sid=QACTIVE&ovc=MG2012.FrameAndLegColour%3DA%3BMG2012.Columns%3D333%3BMG2012.MetalFeet%3DF%3BMG2012.PowerPlug%3DEU%3BMG2012.Button%3DUA&lang=de&sp=true&HOOK_URL=https://wbconnect.de/plenty/set-variation/10359";
            } else {
                return part1 + this.itemId;
            }
        },
        isQuickView() {
            return this.itemData !== null;
        },

        currentVariation() {
            return this.$store.getters[`${this.usedItemId}/currentItemVariation`]
        },

        isItemView() {
            return App.isItemView;
        },

        carouselImages() {
            const varImages = this.getImages("variation", true);
            const ItemImages = this.getImages("item", true).slice(0, 25);
            let images = [...varImages];  // ...ItemImages




            // if(this.currentVariation.variation.isMain){
            //   images = [...varImages, ...ItemImages];  // ...ItemImages
            // }


            return this.appendFreeField(images);
        },

        singleImages() {
            const varImages = this.getImages("variation", false);
            const ItemImages = this.getImages("item", false).slice(0, 25);

            let images = [...varImages];  // ...ItemImages

            // if(this.currentVariation.variation.isMain){
            //   images = [...varImages, ...ItemImages];  // ...ItemImages
            // }

            return this.appendFreeField(images);
        },

        photoSwipeImages() {

            let newPics = [];

            const varImages = this.getImages("variation", false);
            const ItemImages = this.getImages("item", false).slice(0, 25);
            let images = [...varImages]; // ...ItemImages

            for (let key in images) {
                newPics.push({
                    alternate: "",
                    url: images[key].url,
                    position: images[key].position
                });
            }

            images = this.$options.filters.photoSwipeItemImages(
                newPics,
                this.imageUrlAccessor);

            return images;
        },

        getImageCount() {
            return this.carouselImages.length > 25 ? 25 : this.carouselImages.length;
        },

        freeFieldsComp() {
            return this.currentVariation.free;
        }
    },

    watch: {
        currentVariation:
        {
            handler(val, oldVal) {
                if (val !== oldVal) {
                    setTimeout(() => {
                        this.varSwitched = true;
                        this.reInitialize();
                    }, 1);
                }
            },
            deep: true
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.initThumbCarousel();
            this.initCarousel();
        })
    },

    methods:
    {
        getItemName() {
            return this.$options.filters.itemName(this.currentVariation);
        },

        getImages(target = "item", isPreview) {
            if (!this.currentVariation.images[target]) { // TODO: fix für quickview
                return [];
            }
            const images = this.currentVariation.images[target].map(img => {
                return {
                    url: isPreview ? img.urlPreview : img.url,
                    urlBig: img.url,
                    alternate: img.names ? img.names.alternate : null,
                    position: img.position,
                    urlMiddle: img.urlMiddle
                };
            });
            return this.orderByPosition(images);
        },

        reInitialize() {
            this.thumbsSwiper.destroy();
            this.singleSwiper.destroy();

            this.$nextTick(() => {
                this.initThumbCarousel();
                console.log("test2")
                this.initCarousel();
            });
        },

        initCarousel() {
            const imageCount = this.getImageCount;

            const $singleRef = $(this.$refs.single);
            let thumbsSwiper = this.thumbsSwiper;
            let el = ".single .single-swiper";
            let elStart = ".single ";
            let _this = this;
            let that = this;

            if (this.itemData !== null) {
                el = ".quick-view__wrapper .single-swiper";
                elStart = ".quick-view__wrapper ";
            }

            this.singleSwiper = new Swiper(el, {
                spaceBetween: 10,
                loopedSlides: imageCount,

                loop: imageCount >= 6,//true,//false,//true,//imageCount > 4,
                //allowTouchMove: false,
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 2,
                    checkInView: true,
                    loadOnTransitionStart: true,
                },
                pagination: {
                    el: '.single-swiper-pagination',
                    clickable: true,
                    // fix for: bullet pagination does not update in swipe or thumb click
                    // https://github.com/nolimits4web/swiper/issues/2915#issuecomment-807980596
                    type: 'custom',
                    renderCustom: function (swiper, current, total) {
                        let out = ''
                        for (let i = 1; i < total + 1; i++) {
                            if (i == current) {
                                out = out + '<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex=' + i + ' role="button" aria-label="Go to slide ' + parseInt(i) + 1 + '"></span>';
                            }
                            else {
                                out = out + '<span class="swiper-pagination-bullet" tabindex=' + i + ' role="button" aria-label="Go to slide ' + parseInt(i) + 1 + '"></span>';
                            }
                        }
                        return out;
                    },
                },
                navigation: {
                    nextEl: elStart + '.swiper-button-next',
                    prevEl: elStart + '.swiper-button-prev',
                },

                on: {
                    // slideChange: (thisSwiper) => {
                    //     this.currentItem = thisSwiper.realIndex + 1;
                    // },

                    afterInit: () => {
                        this.initialized = true;
                    },

                    slideChangeTransitionEnd: (thisSwiper) => {
                        if (!!document.querySelector(".swiper-slide-active .responsive-iframe--3d iframe")) {
                            document.querySelector(".responsive-iframe--3d iframe").setAttribute("src", document.querySelector(".responsive-iframe--3d iframe").dataset.src);
                        }
                    },
                },
                thumbs: {
                    swiper: imageCount < 6 ? this.thumbsSwiper : null,
                    slideThumbActiveClass: imageCount >= 6 ? 'swiper-slide-thumb-active' : 'swiper-slide-active',
                }
            });

            let singleSwiper = this.singleSwiper;

            thumbsSwiper.on("slideChange", function () {
                //singleSwiper.slideTo(thumbsSwiper.realIndex);

                // wenn modal offen ist, img src setzen
                if ($('.single__swiper-full-screen-modal').hasClass('is-open')) {
                    setTimeout(function () {
                        let sel = $('.single__swiper-full-screen-modal .single__thumb-swiper .swiper-slide-thumb-active').length ? ".swiper-slide-thumb-active" : '.swiper-slide-active';
                        switch ($('.single__swiper-full-screen-modal .single__thumb-swiper ' + sel + ' > *')[0].dataset.type) {
                            case "img":
                                $('.single__swiper-full-screen-modal-iframe').hide();
                                $('.single__swiper-full-screen-modal-img').show().attr("src", $('.single__swiper-full-screen-modal .single__thumb-swiper ' + sel + ' img')[0].dataset.bigimg);
                                break;
                            case "video":
                                $('.single__swiper-full-screen-modal-img').hide();
                                $('.single__swiper-full-screen-modal-iframe').show().attr("src", "https://www.youtube-nocookie.com/embed/" + $('.single__swiper-full-screen-modal .single__thumb-swiper ' + sel + ' div')[0].dataset.url);
                                break;
                            case "3d":
                                $('.single__swiper-full-screen-modal-img').hide();
                                $('.single__swiper-full-screen-modal-iframe').show().attr("src", $('.single__swiper-full-screen-modal .single__thumb-swiper ' + sel + ' div')[0].dataset.url);
                                break;
                        }
                        $('.single__swiper-full-screen-modal-img-wrapper').scrollTop(0);
                    }, 100);
                }
            });

            if (!isNullOrUndefined(window.lightbox)) {
                window.lightbox.option({
                    wrapAround: true
                });
                window.lightbox.imageCountLabel = (current, total) => {
                    if (isNullOrUndefined(imageCount) || imageCount <= 1) {
                        return "";
                    }
                    current -= ((total - imageCount) / 2);
                    while (current <= 0) {
                        current += imageCount;
                    }
                    while (current > imageCount) {
                        current -= imageCount;
                    }
                    return TranslationService.translate("Ceres::Template.singleItemImagePreviewCaption", { current: current, total: imageCount });
                };

                const originalFn = window.lightbox.changeImage;

                window.lightbox.changeImage = imageNumber => {
                    if (window.lightbox.currentImageIndex === 0 && imageNumber === window.lightbox.album.length - 1) {
                        imageNumber--;
                    }
                    else if (window.lightbox.currentImageIndex === window.lightbox.album.length - 1 && imageNumber === 0) {
                        imageNumber++;
                    }
                    return originalFn.call(window.lightbox, imageNumber);
                };
            }

            if (window.innerWidth > 1200 && !(('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0))) {
                const driftImgs = document.querySelectorAll('.single__swiper-image');
                const pane = document.querySelector('.drift-pane-' + this.currentVariation.item.id);
                Object.values(driftImgs).map(img => {
                    if (this.isQuickView) {
                        window.driftzoom = new Drift(img, {
                            paneContainer: pane,
                            inlinePane: false,
                            hoverBoundingBox: true,
                            onShow: function () {
                                setTimeout(function () {
                                    if (!!document.querySelector(".drift-bounding-box.drift-open")) {
                                        document.querySelector(".drift-bounding-box.drift-open").classList.add("visible-bounding-box")
                                    }
                                }, 250)
                            }
                        });
                    } else {
                        window.singleDriftZoom = new Drift(img, {
                            paneContainer: pane,
                            inlinePane: false,
                            hoverBoundingBox: true,
                            onShow: function () {
                                setTimeout(function () {
                                    if (!!document.querySelector(".drift-bounding-box.drift-open")) {
                                        document.querySelector(".drift-bounding-box.drift-open").classList.add("visible-bounding-box")
                                    }
                                }, 250)
                            }
                        });
                    }
                });

                setTimeout(function () {
                    window.scrollTo(0, window.scrollY + 1)
                }, 100);

            }

            // console.log(this.singleSwiper)
            if (imageCount >= 6) {
                this.thumbsSwiper.controller.control = this.singleSwiper;
                this.singleSwiper.controller.control = this.thumbsSwiper;
            }
        },

        initThumbCarousel() {

            const imageCount = this.getImageCount;

            const $thumbsRef = $(this.$refs.thumbs);

            if (imageCount <= 6) {
                $thumbsRef.addClass("no-loop");
            }

            let el = ".single .single__thumb-swiper";
            let elStart = ".single ";

            if (this.itemData !== null) {
                el = ".quick-view__wrapper .single__thumb-swiper";
                elStart = ".quick-view__wrapper ";
            }

            console.log(imageCount)

            let _this = this;

            this.thumbsSwiper = new Swiper(el, {
                spaceBetween: 5,
                loopedSlides: imageCount,
                centeredSlides: imageCount >= 6,//false,//imageCount > 4,
                slidesPerView: _this.isQuickView ? 5 : 7,
                slideToClickedSlide: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                observer: true,
                multipleActiveThumbs: false,
                loop: imageCount >= 6,// true,//false,//imageCount > 4,
                direction: 'vertical',
                allowTouchMove: false,
                slideActiveClass: imageCount >= 6 ? 'swiper-slide-active' : 'swiper-slide-active2',
                slideThumbActiveClass: imageCount >= 6 ? 'swiper-slide-thumb-active' : 'swiper-slide-active',
                mousewheel: {
                    sensitivity: 1
                },
                lazy: {
                    loadPrevNext: true,
                    loadPrevNextAmount: 2,
                    checkInView: true,
                    loadOnTransitionStart: true,
                },
                navigation: {
                    nextEl: elStart + '.thumb-swiper-next',
                    prevEl: elStart + '.thumb-swiper-prev',
                },
                on: {
                    click: () => {
                        this.setLightBoxImage(imageCount);
                    },
                    tap: (swiper, event) => {
                        this.setLightBoxImage(imageCount);
                    },
                    afterInit: () => {
                        if (_this.itemData !== null && !_this.varSwitched) {
                            setTimeout(function () {
                                window.dispatchEvent(new Event('resize'));
                            }, 250);
                            let tsInterval = setInterval(function () {
                                if (!!document.querySelector(elStart + ".single__thumb-swiper .swiper-slide-next.swiper-slide-thumb-active") && !!document.querySelector(elStart + ".single__thumb-swiper .swiper-slide-active")) {
                                    clearInterval(tsInterval);
                                    document.querySelector(elStart + ".single__thumb-swiper .swiper-slide-next.swiper-slide-thumb-active").classList.remove("swiper-slide-thumb-active");
                                    document.querySelector(elStart + ".single__thumb-swiper .swiper-slide-active").classList.add("swiper-slide-thumb-active");
                                }

                            }, 250);

                            setTimeout(function () {
                                clearInterval(tsInterval);
                                if (!!document.querySelector(elStart + ".single__thumb-swiper .swiper-slide-next.swiper-slide-thumb-active") && !!document.querySelector(elStart + ".single__thumb-swiper .swiper-slide-active")) {
                                    clearInterval(tsInterval);
                                    document.querySelector(elStart + ".single__thumb-swiper .swiper-slide-next.swiper-slide-thumb-active").classList.remove("swiper-slide-thumb-active");
                                    document.querySelector(elStart + ".single__thumb-swiper .swiper-slide-active").classList.add("swiper-slide-thumb-active");
                                }
                            }, 2500);
                        }
                    }
                },
            });
        },

        setLightBoxImage(imageCount) {

            // if(imageCount <= 4){
            //     this.thumbsSwiper.slideTo(this.singleSwiper.realIndex);
            // }

            let elStart = ".single ";

            if (this.itemData !== null) {
                elStart = ".quick-view__wrapper ";
            }

            if ($('.single__swiper-full-screen-modal').hasClass('is-open')) {
                setTimeout(function () {
                    let sel = $('.single__swiper-full-screen-modal .single__thumb-swiper .swiper-slide-thumb-active').length ?
                        ".swiper-slide-thumb-active" : '.swiper-slide-active';
                    switch ($('.single__swiper-full-screen-modal .single__thumb-swiper ' + sel + ' > *')[0].dataset.type) {
                        case "img":
                            $('.single__swiper-full-screen-modal-iframe').hide();
                            $('.single__swiper-full-screen-modal-img').show().attr("src", $('.single__swiper-full-screen-modal .single__thumb-swiper ' + sel + ' img')[0].dataset.bigimg);
                            break;
                        case "video":
                            $('.single__swiper-full-screen-modal-img').hide();
                            $('.single__swiper-full-screen-modal-iframe').show().attr("src", "https://www.youtube-nocookie.com/embed/" + $('.single__swiper-full-screen-modal .single__thumb-swiper ' + sel + ' div')[0].dataset.url);
                            break;
                        case "3d":
                            $('.single__swiper-full-screen-modal-img').hide();
                            $('.single__swiper-full-screen-modal-iframe').show().attr("src", $('.single__swiper-full-screen-modal .single__thumb-swiper ' + sel + ' div')[0].dataset.url);
                            break;
                    }
                    $('.single__swiper-full-screen-modal-img-wrapper').scrollTop(0);
                }, 100);
            }
        },

        orderByPosition(list) {
            return list.sort(
                (entryA, entryB) => {
                    if (entryA.position > entryB.position) {
                        return 1;
                    }
                    if (entryA.position < entryB.position) {
                        return -1;
                    }

                    return 0;
                });
        },

        getAltText(image) {
            return image && image.alternate ? image.alternate : this.$options.filters.itemName(this.currentVariation);
        },

        getImageName(image) {
            return image && image.name ? image.name : this.$options.filters.itemName(this.currentVariation);
        },

        appendFreeField(images) {

            if (this.itemData !== null) {
                if (this.itemData.item.free5) {
                    images.push(
                        {
                            position: 98,
                            url: this.itemData.item.free5,
                            isVideo: true,
                            isYoutube: true
                        }
                    );
                }
                if (this.itemData.item.free10) {
                    images.push(
                        {
                            position: 97,
                            url: this.itemData.item.free10,
                            isVideo: true,
                            isYoutube: false
                        }
                    );
                }

                if (this.itemData.item.free6) {
                    images.push(
                        {
                            position: 99,
                            url: this.itemData.item.free6,
                            is3d: true
                        }
                    );
                }
            } else {
                if (this.currentVariation.item && this.currentVariation.item.free10) {
                    images.push(
                        {
                            position: 97,
                            url: this.currentVariation.item.free10,
                            isVideo: true,
                            isYoutube: false
                        }
                    );
                }
                if (this.currentVariation.item && this.currentVariation.item.free5) {
                    images.push(
                        {
                            position: 98,
                            url: this.currentVariation.item.free5,
                            isVideo: true,
                            isYoutube: true
                        }
                    );
                }

                if (this.currentVariation.item && this.currentVariation.item.free6) {
                    images.push(
                        {
                            position: 99,
                            url: this.currentVariation.item.free6,
                            is3d: true
                        }
                    );
                }
            }

            return images;
        },

        openFullScreenModal(event) {
            let elStart = ".single ";

            if (this.itemData !== null) {
                elStart = ".quick-view__wrapper ";
            }

            if (window.innerWidth > 991) {

                $.each($(elStart + '.single-swiper a'), function (index, item) {
                    delete $(item)[0].dataset.lightbox;
                });

                $('.single__swiper-full-screen-modal').addClass('is-open');

                // move in body wegen ipad pinch zoom
                $(".single__swiper-full-screen-modal").detach().appendTo('body');

                $(elStart + '.single__thumb-swiper-container').addClass('is-open');

                // move in body wegen ipad pinch zoom
                $(elStart + ".single__thumb-swiper-container").detach().appendTo('.single__swiper-full-screen-modal');

                $('body').addClass('full-screen-modal-open');

                this.transform = $(elStart + 'div[itemscope="itemscope"]').css('transform');
                $(elStart + 'div[itemscope="itemscope"]').css('transform', 'unset').addClass("no-transition");

                // set inital img
                let $sel = $('.single__swiper-full-screen-modal .single__thumb-swiper .swiper-slide-thumb-active img').length ?
                    $('.single__swiper-full-screen-modal .single__thumb-swiper .swiper-slide-thumb-active img') :
                    $('.single__swiper-full-screen-modal .single__thumb-swiper .swiper-slide-active img');
                $('.single__swiper-full-screen-modal-img').show().attr("src", $sel[0].dataset.bigimg);
                $('.single__swiper-full-screen-modal-iframe').hide();
            }
        },

        closeModal() {
            let elStart = ".single ";

            if (!!document.querySelector(".quick-view__wrapper")) {
                elStart = ".quick-view__wrapper ";
            }
            $('.single__swiper-full-screen-modal').removeClass('is-open');

            // wieder zurück moven
            $(".single__swiper-full-screen-modal").detach().appendTo(elStart + 'div[itemscope="itemscope"]');
            $(".single__swiper-full-screen-modal .single__thumb-swiper-container").detach().prependTo(elStart + 'div[itemscope="itemscope"]');

            $(elStart + '.single__thumb-swiper-container').removeClass('is-open');
            $('body').removeClass('full-screen-modal-open');
            $(elStart + 'div[itemscope="itemscope"]').css('transform', this.transform).removeClass("no-transition");
        },

        openPhotoSwiper() {
            if (window.innerWidth <= 991) {
                const index = this.singleSwiper.realIndex;
                const pswpElement = document.querySelectorAll(
                    '.pswp')[0]; // swiper-slide

                // define options (if needed)
                const options = {
                    // optionName: 'option value'
                    // for example:
                    index: index, // start at first slide
                    hideAnimationDuration: 0,
                    showAnimationDuration: 0,
                    history: false,
                    maxSpreadZoom: 3,
                    //showHideOpacity: true,
                    preload: [3, 3]

                };

                // Initializes and opens PhotoSwipe
                const gallery = new PhotoSwipe(pswpElement,
                    PhotoSwipeUI_Default, this.photoSwipeImages,
                    options);

                gallery.listen('gettingData', function (index, item) {
                    if (item.w < 1 || item.h < 1) { // unknown size

                        const img = new Image();

                        img.onload = function () { // will get size after load

                            item.w = this.width; // set image width
                            item.h = this.height; // set image height

                            gallery.invalidateCurrItems(); // reinit
                            // Items
                            gallery.updateSize(true); // reinit Items
                        };
                        img.src = item.src; // let's download image
                    }
                });
                gallery.listen('beforeChange', function (index, item) {
                    if (typeof gallery.currItem.container !== "undefined" && gallery.currItem.container !== null) {
                        //gallery.currItem.container.classList.add("visible")
                    }
                });

                for (let key in this.photoSwipeImages) {
                    var img = new Image();
                    img.src = this.photoSwipeImages[key].src;
                }

                gallery.init();
            }
        },

        triggerScrollForDrift() {
            setTimeout(function () {
                window.scrollTo(0, window.scrollY + 1)
            }, 100);
        },

        triggerClick(target) {
            target.closest(".swiper-slide").click();
        }
    }
}
</script>
